var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cccccb;\n      }\n\n      .cls-2 {\n        fill: #1f2f60;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #f0efef;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Taxes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1014.79,885.68l-85.2-85.05c-5.85-5.9-15.38-5.94-21.29-.09-.03.03-.06.06-.09.09l-42.45,42.45c-5.9,5.85-5.94,15.38-.09,21.29.03.03.06.06.09.09,90.31,90.31,92.27,98.29,116.96,98.29,24.94.06,45.21-20.11,45.27-45.05.03-12.01-4.72-23.53-13.21-32.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.31,958.23c0,24.94-20.22,45.16-45.16,45.16H200.16c-24.39.5-44.58-18.82-45.16-43.2V173.55c.58-24.38,20.77-43.7,45.16-43.2,483.33,0,452.78,0,457.29,1.2s-6.92-8.73,155.49,153.69c6.62,6.62,4.37-30.56,4.37,672.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.73,205.61c-24.94,0-45.16,20.22-45.16,45.16v240.84c0,8.31,6.74,15.05,15.05,15.05h60.21c8.31,0,15.05-6.74,15.05-15.05v-240.84c0-24.94-20.22-45.16-45.16-45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M486.15,280.87c-24.94,0-45.16,20.22-45.16,45.16v165.58c0,8.31,6.74,15.05,15.05,15.05h60.21c8.31,0,15.05-6.74,15.05-15.05v-165.58c0-24.94-20.22-45.16-45.16-45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M606.57,356.14c-24.94,0-45.16,20.22-45.16,45.16v90.31c0,8.31,6.74,15.05,15.05,15.05h60.21c8.31,0,15.05-6.74,15.05-15.05v-90.31c0-24.94-20.22-45.16-45.16-45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M651.73,506.66h-331.15c-8.31,0-15.05-6.74-15.05-15.05s6.74-15.05,15.05-15.05h331.15c8.31,0,15.05,6.74,15.05,15.05s-6.74,15.05-15.05,15.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M625.39,612.03h-319.86c-8.31,0-15.05-6.74-15.05-15.05s6.74-15.05,15.05-15.05h319.86c8.31,0,15.05,6.74,15.05,15.05s-6.74,15.05-15.05,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M591.52,702.34h-286c-8.31,0-15.05-6.74-15.05-15.05s6.74-15.05,15.05-15.05h286c8.31,0,15.05,6.74,15.05,15.05s-6.74,15.05-15.05,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.93,792.65h-302.4c-8.31,0-15.05-6.74-15.05-15.05s6.74-15.05,15.05-15.05h302.4c8.31,0,15.05,6.74,15.05,15.05s-6.74,15.05-15.05,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M698.99,882.97h-393.47c-8.31,0-15.05-6.74-15.05-15.05s6.74-15.05,15.05-15.05h393.47c8.31,0,15.05,6.74,15.05,15.05s-6.74,15.05-15.05,15.05Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 772.15,
    cy: 702.34,
    r: 195.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M807.97,309.77c-4.06,1.66,5.27,1.2-126.14,1.2-24.94,0-45.16-20.21-45.17-45.14,0-.36,0-.71.01-1.07v-119.37c.04-8.31,6.81-15.02,15.13-14.98,1.94,0,3.85.39,5.65,1.13,4.52,1.96-6.92-8.73,155.49,153.69,5.86,5.9,5.83,15.43-.07,21.29-1.4,1.39-3.07,2.5-4.9,3.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.23,710.62c-24.62,3.99-41.35,27.17-37.36,51.79,3.99,24.62,27.17,41.35,51.79,37.36,11.8-1.91,22.36-8.42,29.37-18.11,14.62-20.21,10.09-48.44-10.11-63.06-9.72-7.03-21.84-9.91-33.69-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M706.07,694.06c24.61-4.16,41.19-27.47,37.03-52.08-4.16-24.61-27.47-41.19-52.08-37.03-57.65,9.33-44.71,98.59,15.05,89.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M821.67,608.11l-123.43,170.84c-4.82,6.77-3.24,16.17,3.53,20.99,2.53,1.8,5.56,2.78,8.66,2.79,10.99,0,3.01,6.62,135.47-177.02,4.2-7.17,1.79-16.4-5.39-20.59-6.19-3.62-14.08-2.37-18.85,2.98h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.924acc4e159c06d9fc023e9d2411288e.svg";
export { ForwardRef as ReactComponent };